import type { Formula } from "./formula";

export interface MatchExpression<T> {
  readonly type: "MATCH_EXPR";
  readonly cases: MatchCase<T>[];
  readonly defaultValue: T;
}

export interface MatchCase<T> {
  readonly condition: Formula;
  readonly value: T;
}

export function isMatchExpression<T>(v: any): v is MatchExpression<T> {
  return !!v && typeof v === "object" && Object.hasOwn(v, "type") && v.type === "MATCH_EXPR";
}
